import React, { Suspense } from "react";
import { useTranslation } from "react-i18next";
import { Col, Spin } from "antd";

import UnhandledType from "./fields/UnhandledType";
import formFieldComponents from "../Patient/ApplicationFormEditor/components/form/utils/formFieldComponents";
import { getFieldName, getValidationRules } from "../Patient/ApplicationFormEditor/utils/renderReactFromJson";

export const PreviewField = ({ field, span, value, sectionName, form }) => {
  const { t } = useTranslation();

  if (!field || !field.type) {
    console.error("Invalid field:", field);
    return null;
  }
  const type = field.type?.replace(/ /g, "_");

  const FieldComponent = formFieldComponents[type] || UnhandledType;

  return (
    <Col span={span}>
      <Suspense fallback={<Spin size="small" />}>
        <FieldComponent
          type={field.type}
          name={getFieldName(sectionName, field)}
          required={field.required}
          placeholder={field.placeholder}
          rules={getValidationRules(field || {})}
          value={value}
          field={field}
          label={t(field.label)}
          fieldProps={field.fieldProps}
          form={form}
          formItemProps={{
            initialValue: field.defaultValue,
            ...field.formItemProps
          }}
          {...field.dedicatedFieldProps}
        />
      </Suspense>
    </Col>
  );
};
